import type { QueryClient } from '@tanstack/react-query';

import { offerRequestDetailQueryOptions } from './useOfferRequestDetail';

export async function prefetchOfferRequestDetailPage(
    queryClient: QueryClient,
    offerRequestLeadUuid: string,
): Promise<void> {
    await queryClient.ensureQueryData(offerRequestDetailQueryOptions(offerRequestLeadUuid));
}
